!function() {
  "use strict";

  customElements.get("sibling-swatches") || customElements.define("sibling-swatches", class extends HTMLElement {
    constructor() {
      super();

      this.productBlock = this.closest("[data-product-block]");

      if (this.productBlock) {
        this.mainImageContainer = this.productBlock.querySelector("[data-main-image]");
        this.mainImage = this.mainImageContainer?.querySelector("img");
        this.productLinks = this.productBlock.querySelectorAll("[data-grid-link]");
        this.siblingSwatches = this.querySelectorAll("[data-sibling-swatch]");

        this.originalProductUrl = this.getAttribute("data-product-url");
        this.originalSrcset = this.mainImage?.getAttribute("srcset");
        this.originalSrc = this.mainImage?.getAttribute("src");

        this.siblingColorLabel = this.productBlock.querySelector("[data-sibling-color-label]");
        this.siblingColorValue = this.productBlock.querySelector("[data-sibling-color-value]");

        this.priceContainer = this.productBlock.querySelector("[data-product-price-container]");
        this.badgesContainer = this.productBlock.querySelector("[data-product-badges-container]");

        this.originalPriceHtml = this.priceContainer ? this.priceContainer.innerHTML : "";
        this.originalBadgesHtml = this.badgesContainer ? this.badgesContainer.innerHTML : "";

        this.originalSiblingColor = this.siblingColorValue ? this.siblingColorValue.textContent.trim() : "";
      }
    }

    connectedCallback() {
      this.siblingSwatches.forEach((swatch) => {
        swatch.addEventListener("mouseenter", () => this.updateProduct(swatch));
        swatch.addEventListener("focus", () => this.updateProduct(swatch));
      });

      this.addEventListener("mouseleave", this.resetProduct.bind(this));
    }

    updateSiblingColor(color) {
      if (!this.siblingColorLabel || !this.siblingColorValue) return;

      if (color) {
        this.siblingColorValue.textContent = color;
        this.siblingColorLabel.hidden = false;
      } else {
        this.siblingColorValue.textContent = "";
        this.siblingColorLabel.hidden = true;
      }
    }

    updateProduct(swatch) {
      const imageUrl = swatch.getAttribute("data-sibling-featured-image-url");
      const siblingColor = swatch.getAttribute("data-sibling-color");
      const siblingUrl = swatch.getAttribute("href");

      const priceTemplate = swatch.querySelector("[data-sibling-price-template]");
      const badgesTemplate = swatch.querySelector("[data-sibling-badges-template]");

      if (siblingUrl) {
        this.productLinks.forEach((link) => link.setAttribute("href", siblingUrl));
      }

      if (imageUrl && this.mainImage) {
        this.mainImage.setAttribute("srcset", imageUrl);
        this.mainImage.setAttribute("src", imageUrl);
      }

      if (this.priceContainer && priceTemplate) {
        this.priceContainer.innerHTML = priceTemplate.innerHTML.trim();
      }

      if (this.badgesContainer && badgesTemplate) {
        this.badgesContainer.innerHTML = badgesTemplate.innerHTML.trim();
      }

      this.updateSiblingColor(siblingColor);
    }

    resetProduct() {
      this.productLinks.forEach((link) => link.setAttribute("href", this.originalProductUrl));

      if (this.mainImage) {
        this.mainImage.setAttribute("srcset", this.originalSrcset);
        this.mainImage.setAttribute("src", this.originalSrc);
      }

      if (this.priceContainer) {
        this.priceContainer.innerHTML = this.originalPriceHtml;
      }

      if (this.badgesContainer) {
        this.badgesContainer.innerHTML = this.originalBadgesHtml;
      }

      this.updateSiblingColor(this.originalSiblingColor);
    }
  });
}();